var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group input-daterange"},[_c('input',{ref:"start",staticClass:"form-control"}),_vm._v(" "),_c('div',{staticClass:"input-group-addon"},[_vm._v("to")]),_vm._v(" "),_c('input',{ref:"end",staticClass:"form-control"})])}
var staticRenderFns = []

export { render, staticRenderFns }